import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Placeholder } from "rsuite";
import styles from "../master.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faPen, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import apiUrl from "../../apiUrlConstant";
import { Link } from "react-router-dom";


const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const FilterComponent = ({ filterText, onFilter, onClear, fetchAssetsDetails }) => (
  <>
    <ClearButton type="button" onClick={() => { DownloadFile(filterText) }} className="download_button">
      {/* <FontAwesomeIcon icon={faFileExcel} /> */}
      Download
    </ClearButton>
    <TextField
      id="search"
      type="text"
      placeholder="Search"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="searchBtn"
    />
    <ClearButton type="button" onClick={onClear}>
      <FontAwesomeIcon icon={faSearch} />
    </ClearButton>

    {/* <a href={`${apiUrl.apiUrl.url}/unit-detail/index?term=${filterText}&asset=${fetchAssetsDetails}&export=true`}> onClick={apiUrl.apiUrl.url+'/lease-report/generate-summary-report?'}*/}

    {/* </a> */}
  </>
);
function DownloadFile(filterText, fetchAssetsDetails) {
  // var prm = Object.entries(formConfig).map(([key, val]) => `${key}=${val}`).join('&');  
  var self = this;
  axios({
    method: "post",
    url: `${apiUrl.apiUrl.url}/unit-detail/index?term=${filterText}&asset=${fetchAssetsDetails}&export=true&sendLink=true`,
    // data: columnsList,
  }).then(function (response) {
    window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response.data}`;
  });

}

const Table = (assetId) => {
  var fetchAssetsId = typeof assetId.assetId == "undefined" ? 0 : assetId.assetId;

  const [filterText, setFilterText] = React.useState("");
  const [fetchAssetsDetails, setAssetID] = React.useState(fetchAssetsId);
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);



  React.useEffect(() => {
    fetchUnits(1);
  }, [filterText]);


  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };


    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
          //alert(e.target.value);

          //fetchUnits(1);
        }}
        onClear={handleClear}
        filterText={filterText}
        fetchAssetsDetails={fetchAssetsDetails}
      />
    );
  }, [filterText, fetchAssetsDetails, resetPaginationToggle]);

  const fetchUnits = async (page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/unit-detail/index?page=${page}&per_page=${perPage}&term=${filterText}&asset=${fetchAssetsId}`
    );

    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchUnits(page);
  };


  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/unit-detail/index?page=${page}&per_page=${newPerPage}&delay=1`
    );

    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  var columns = [
    {
      name: "S.No",
      selector: "srNo",
      sortable: false,
      width: "70px",
    },
    {
      name: "Asset Name",
      selector: "assetName",
      sortable: false,
      wrap: true,
    },
    {
      name: "Floor",
      selector: "floor",
      sortable: false,
      wrap: true,
    },
    {
      name: "Unit No",
      selector: "unitNumber",
      sortable: false,
      wrap: true,
    },
    {
      name: "Unit Status",
      selector: "unitStatus",
      sortable: false,
      wrap: true,
    },
    // {
    //   name: "Availability",
    //   selector: "availability",
    //   sortable: false,
    //   wrap: true,
    //   show: false
    // },
    // {
    //   name: "Unit Ownership",
    //   selector: "unitOwnership",
    //   sortable: false,
    //   wrap: true,
    //   show: false
    // },
    {
      name: "Gross Leasable Area (Sq. Ft.)",
      selector: "grossLeasableArea",
      sortable: false,
      wrap: true,
    },
    {
      name: "Information",
      selector: (row) => `${row.created_by} ${row.created_at}`,
      sortable: false,
      wrap: true,
      grow: 2,
    },
    {
      name: "Action",
      // selector: "info",
      sortable: false,
      width: "70px",
      cell: (record) => {
        return (
          <div>
            {(!fetchAssetsId) && (
              <span className="tableActionEdit">
                <Link to={`/masters/unit-detail/${record.id}`}>
                  {" "}
                  <FontAwesomeIcon icon={faPen} />
                </Link>
              </span>
            )}
          </div>
        );
      },
    },
  ];

  if (fetchAssetsId) {
    delete columns[7];
    delete columns[6];

  }

  useEffect(() => {
    fetchUnits(1);
  }, []);

  return (
    <div className="tableContainer">
      <DataTable
        title="Unit Details"
        columns={columns}
        data={data}
        customStyles={datatableOptions.datatableOptions.customStyle}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        onChangePage={handlePageChange}
        paginationComponentOptions={
          datatableOptions.datatableOptions.paginationOptions
        }
      />
    </div>
  );
};
export default Table;
